import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>MeowBox Studios</h3>
            <p>Creating immersive Roblox experiences</p>
          </div>
          <div className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/games">Games</Link>
            <Link to="/team">Team</Link>
            <Link to="/careers">Careers</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MeowBox Studios. All rights reserved.</p>
          <p className="footer-credit">Built with React • Powered by Roblox Studio</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
